import { AuthUserService, IAuthUser } from '../services/authusers.service';
import { EmployeesService, IEmployee } from '../../services/index';
import * as _ from "lodash";
class AuthSettingsUsersItemController implements ng.IComponentController {

    private authUser: IAuthUser;
    private fieldedit: any;
    private roleedit: any;
    private employees: IEmployee[] = [];
    private selectedEmployeeId: string = null;
    private selectedRole: string = null;
    private selectedClaimKey: string = null;
    private availableRoles: string[] = ['employee', 'backoffice', 'superuser', 'timesheets', 'finance', 'admin', 'customer'];
    private availableClaimKeys: string[] = ['displayName', 'employeeId', 'customerId'];

    constructor(
        private AuthUserService: AuthUserService,
        private EmployeesService: EmployeesService,
        private $q: ng.IQService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.EmployeesService.getEmployeesByStatus().then((employees) => {
            this.employees = employees || [];
        });

        this.AuthUserService.getRoles(this.authUser).then((roles) => {
            this.authUser.roles = roles;
        });

        this.AuthUserService.getClaims(this.authUser).then((claims) => {
            this.authUser.claims = new Object();
            for(var i = 0; i < claims.length; i++){
                var item = claims[i];
                this.authUser.claims[item.type] = item.value;
            }
            if (this.authUser.claims && this.authUser.claims["employeeId"]) {
                this.selectedEmployeeId = this.authUser.claims["employeeId"];
            }
            // console.log(this.authUser.claims);
        });
    }

    public save = () => {

        this.AuthUserService.post(this.authUser).then((response) => {
            // console.log(response);
        })

    }

    public createAccount = () => {
        this.authUser.userName = this.authUser.email;

        this.ensureClaimsAndRoles();
        this.applyEmployeeClaim();

        this.AuthUserService.post(this.authUser).then((response) => {
            this.syncEmployeeLink(null, this.selectedEmployeeId, response.id).then(() => {
                // console.log('Account created');
            });
        })
    }

    public updateUser = () => {
        const previousEmployeeId = this.authUser.claims ? this.authUser.claims["employeeId"] : null;
        this.ensureClaimsAndRoles();
        this.applyEmployeeClaim();

        this.AuthUserService.put(this.authUser.id, this.authUser).then((response) => {
            this.syncEmployeeLink(previousEmployeeId, this.selectedEmployeeId, this.authUser.id).then(() => {
                // console.log('Account updated')
            });
        })
    }

    public resetPassword = () => {
        //this.account = new IAuthUser();

        this.AuthUserService.resetPassword(this.authUser).then((response) => {
            //this.accountError = response;
           // console.log('Password reset')
        })
    }


    public editField = (index = null, value = null) => {
        this.deleteField(index, value);
        this.fieldedit.name = index;
        this.fieldedit.value = value;
    }

    public deleteField = (index = null, value = null) => {
        _.unset(this.authUser.claims, index);
    }

    public saveFields = () => {
        if(!this.authUser.claims) {
              this.authUser.claims = {};
        }
        this.authUser.claims[this.fieldedit.name] = this.fieldedit.value;
        this.fieldedit.name = null;
        this.fieldedit.value = null;
    }

    public editRole = (index = null, value = null) => {
        this.deleteRole(index, value);
        this.roleedit.name = value;
    }

    public deleteRole = (index = null, value = null) => {
        this.authUser.roles.splice(index, 1)
    }

    public saveRole = () => {
        if(!this.authUser.roles) {
              this.authUser.roles = [];
        }
        if (this.roleedit.name && this.authUser.roles.indexOf(this.roleedit.name) === -1) {
            this.authUser.roles.push(this.roleedit.name);
        }
        this.roleedit.name = null;
    }

    public addSelectedRole = () => {
        if (!this.selectedRole) {
            return;
        }
        if (!this.authUser.roles) {
            this.authUser.roles = [];
        }
        if (this.authUser.roles.indexOf(this.selectedRole) === -1) {
            this.authUser.roles.push(this.selectedRole);
        }
    }

    public useSelectedClaimKey = () => {
        if (!this.selectedClaimKey) {
            return;
        }
        if (!this.fieldedit) {
            this.fieldedit = {};
        }
        this.fieldedit.name = this.selectedClaimKey;
    }

    private ensureClaimsAndRoles = () => {
        if (!this.authUser.claims) {
            this.authUser.claims = {};
        }
        if (!this.authUser.roles) {
            this.authUser.roles = [];
        }
    }

    private applyEmployeeClaim = () => {
        if (this.selectedEmployeeId) {
            this.authUser.claims["employeeId"] = this.selectedEmployeeId;
        } else if (this.authUser.claims && this.authUser.claims["employeeId"]) {
            delete this.authUser.claims["employeeId"];
        }
    }

    private syncEmployeeLink = (previousEmployeeId: string, newEmployeeId: string, authUserId: string): ng.IPromise<any> => {
        if (previousEmployeeId && previousEmployeeId !== newEmployeeId) {
            this.EmployeesService.get(previousEmployeeId).then((prevEmployee: any) => {
                prevEmployee.userId = null;
                this.EmployeesService.put(previousEmployeeId, prevEmployee);
            });
        }

        if (!newEmployeeId) {
            var deferred = this.$q.defer();
            deferred.resolve();
            return deferred.promise;
        }

        return this.EmployeesService.get(newEmployeeId).then((employee: any) => {
            employee.userId = authUserId;
            return this.EmployeesService.put(newEmployeeId, employee);
        });
    }
}

export const authSettingsUsersItemComponent: ng.IComponentOptions = {
    bindings: {
        authUser: "<"
    },
    controller: AuthSettingsUsersItemController,
    template: require('./authsettings.usersItem.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/authsettings.usersItem.component.ts